import React, {Fragment, Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Panel} from '../common';
import LeaderboardContent from './LeaderboardContent';

export default class Leaderboard extends Component {
  static propTypes = {
    leaders: PropTypes.shape({
      hasMore: PropTypes.bool.isRequired,
      list: PropTypes.arrayOf(PropTypes.shape()).isRequired,
      currentPlayer: PropTypes.shape({
        points: PropTypes.number,
      }).isRequired,
    }).isRequired,
    onFetchPlayersForLeaderboard: PropTypes.func.isRequired,
    sidebarToggle: PropTypes.func.isRequired,
  };

  onSidebarToggle = () => {
    const {sidebarToggle} = this.props;

    sidebarToggle({status: true});
  }

  renderCurrentUserPoints = () => {
    const {leaders: {currentPlayer: {points = 0}}} = this.props;

    return (
      <Fragment>
        <div className="text-center text-xxxx-big text-light">
          Your points: <b>{points}</b>
        </div>
        <Button
          size="l"
          icon="bars"
          className="top-menu-btn"
          handler={this.onSidebarToggle}
        />
      </Fragment>
    );
  };

  render() {
    return (
      <Panel
        title="Leaderboard"
        size="l"
        headerSize="l"
        renderActions={this.renderCurrentUserPoints()}
        cls="leaderboard-page"
      >
        <LeaderboardContent {...this.props} showPeopleOnline/>
      </Panel>
    );
  }
}
